import {HOSTNAME} from "../Configs/Domain";

/**
 * Sends session data to the server using navigator.sendBeacon to ensure that the data is
 * sent reliably even if the page is unloading. This method uses the 'text/plain' content type
 * to avoid CORS preflight checks, which are not supported by navigator.sendBeacon.
 *
 * @param {object} sessionData - The session data to be sent.
 */
export const sendSessionDataToServer = (sessionData) => {
  // Convert the session data object to a plain text string
  const textData = JSON.stringify(sessionData);

  // Create a Blob with text/plain MIME type
  const blob = new Blob([textData], { type: 'text/plain' });

  // Use navigator.sendBeacon to send the data as text/plain
  const url = `${HOSTNAME}/service/session/stats`;
  const sent = navigator.sendBeacon(url, blob);

  if (!sent) {
    console.error('Failed to queue beacon');
  }
};
